import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '../../../atoms/PrimaryButton'
import SecondaryButton from '../../../atoms/SecondaryButton'
import FullScreenPopup from '../../../../components/organisms/FullScreenPopup'
import ProductCommonContext from '../../../../context/common/commonContext'
import {
    mapData,
    dateFormatFunction,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../../common/components'

import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '../../../molecules/Loaders'
import CustomCommonContext from '../../../../../custom/context/common/commonContext'
import BaseActionPage from '../../../species/dynamic/common/BaseActionPage'
import ProductContext from '../../../../context/template/product/productContext'
import AuthContext from '../../../../context/auth/authContext'
import AsinContext from '../../../../context/thirdParty/asin/asinContext'
import HomeContext from '../../../../context/thirdParty/homeDepot/homeContext'
import { findAllByDisplayValue } from '@testing-library/dom'

const ProductFieldsView = (props) => {
    const productContext = useContext(ProductContext)
    const homeContext = useContext(HomeContext)
    const {
        projectAction,
        single_project,
        getSingleProject,
        responseStatus: responseStatusProduct,
    } = productContext
    const authContext = useContext(AuthContext)
    const asinContext = useContext(AsinContext)
    const { user } = authContext
    const {
        responseStatus: responseAsin,
        all_products,
        upc_products,
        retrieveUpcProduct,
        retrieveProduct,
        clearResponse: clearResponseAsin,
    } = asinContext
    const {
        responseStatus: responseHomeDepot,
        all_products: homedepot_products,
        retrieveProduct: retrieveHomeDepot,
        clearResponse: clearResponseHomeDepot,
    } = homeContext
    const { getGlobalVariable, alldata_all_dropdown } =
        useContext(CustomCommonContext)
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(false)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])
    const [addAsinData, setAddAsinData] = useState(false)
    const [asinMapData, setAsinMapData] = useState([])
    const [homeMapData, setHomeMapData] = useState([])
    const [xBarMapData, setXBarMapData] = useState([])
    const [upcMapData, setUpcMapData] = useState([])
    const [propsFieldValue, setPropsFieldValue] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])
    const [fieldData, setFieldData] = useState([])

    const [resetMapData, setResetMapData] = useState(false)

    const [formikValues, setFormikValues] = useState({})
    const [asinValue, setAsinValue] = useState({ record: {} })

    const mapDataValueRef = useRef(mapDataValue)
    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])
    const [customInitialValues, setCustomInitialValues] = useState([])

    useEffect(() => {
        console.log(props.fieldValue, 'valuee')
        let asinMap = props.fieldValue.filter(
            (item) => item.name === 'asin' && item.active === 1
        )
        let homeMap = props.fieldValue.filter(
            (item) => item.name === 'home_depot' && item.active === 1
        )
        let upcMap = props.fieldValue.filter(
            (item) => item.name === 'upc_id' && item.active === 1
        )
        let xBarCodeMap = props.fieldValue.filter(
            (item) => item.name === 'x_barcode' && item.active === 1
        )

        let projectDynamicArray = props.fieldValue.filter(
            (data) =>
                data.name !== 'asin' &&
                data.name !== 'home_depot' &&
                data.name !== 'upc_id' &&
                data.name !== 'x_barcode' &&
                data.active === 1
        )

        if (props.data?.status === 'new') {
            resetFormikAsin()
            resetFormikHome()
            resetFormikUpc()
            resetFormikXBar()
        } else {
            projectDynamicArray.push({
                name: 'wprice',
                value: '',
                type: 'default',
                active: 1,
            })
        }

        setPropsFieldValue(projectDynamicArray)
        console.log(asinMap, 'mapp')
        setAsinMapData(asinMap)
        setUpcMapData(upcMap)
        setHomeMapData(homeMap)
        setXBarMapData(xBarCodeMap)
    }, [props.fieldValue, props.data])

    useEffect(() => {
        let customValidationTemp = {}
        let customInitial = {
            id: 0,
            market_status: 'open',
            auctiontype: 'live',
        }

        customValidationTemp = {
            date_added: Yup.date('Please enter valid Date!')
                .nullable()
                .typeError('Required!')
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .required('Required!'),
            date_closed: Yup.date('Please enter valid Date!')
                .typeError('Required!')
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  new Date(value.replace(/-/g, '/'))
                              ).subtract(1, 'minutes')
                          )
                        : new Date(moment(value).subtract(1, 'minutes'))
                )
                .min(Yup.ref('date_added'), 'Should be greater than start Time')
                .nullable(),
            auction: Yup.boolean().when('buynow', {
                is: (e) => !e,
                then: Yup.boolean().oneOf([true], 'Enable Auction or Buy Now'),
                otherwise: Yup.boolean(),
            }),
            buynow: Yup.boolean().when('auction', {
                is: (e) => !e,
                then: Yup.boolean().oneOf([true], 'Enable Auction or Buy Now'),
                otherwise: Yup.boolean(),
            }),
            sprice: Yup.number().when('auction', {
                is: true,
                then: Yup.number()
                    .required('Required!')
                    .positive('Should be greater than 1'),
            }),
            rprice: Yup.number().when('reverseauction', {
                is: true,
                then: Yup.number()
                    .positive('Should be greater than 1')
                    .max(
                        Yup.ref('sprice'),
                        'Should be equal or less than the starting price'
                    )
                    .required('Required!'),
                otherwise: Yup.number().when('auction', {
                    is: true,
                    then: Yup.number()
                        .positive('Should be greater than 1')
                        .min(
                            Yup.ref('sprice'),
                            'Should be equal or greater than the starting price'
                        )
                        .required('Required!'),
                }),
            }),
            bprice: Yup.number().when('buynow', {
                is: true,
                then: Yup.number()
                    .required('Required!')
                    .positive('Should be greater than 1')
                    .when('auction', {
                        is: true,
                        then: Yup.number().moreThan(
                            Yup.ref('rprice'),
                            'Should be greater than the reserve price'
                        ),
                    }),
            }),
            dimension_length: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            dimension_width: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            dimension_height: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            dimension_unit: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            weight_value: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            weight_unit: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),
            origin_zip: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required('Required!'),
            }),

            ...props.customValidation,
        }
        setCustomInitialValues(customInitial)
        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation])

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            tempMapData.map((mapValue) => {
                if (mapValue.name === 'date_closed') {
                    mapValue.minDate = dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )
                    mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                        formikValues.date_added ? formikValues.date_added : null
                    )}`
                    mapValue.disablePast = true
                } else if (mapValue.name === 'date_added') {
                    mapValue.disablePast = true
                } else if (mapValue.name === 'sprice') {
                    mapValue.disabled = formikValues.auction ? false : true
                } else if (mapValue.name === 'rprice') {
                    mapValue.disabled = formikValues.auction ? false : true
                } else if (mapValue.name === 'bprice') {
                    mapValue.disabled = formikValues.buynow ? false : true
                } else if (mapValue.name === 'dimension_length') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_width') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_height') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_unit') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_value') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_unit') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'origin_zip') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                }
            })
            setReload(!reload)
            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues])

    useEffect(() => {
        if (responseStatusProduct) {
            if (
                responseStatusProduct.status === 'success' &&
                responseStatusProduct.from === 'projectAction'
            ) {
                if (props.standalone) {
                    setIsLoading(false)
                    props.closeFunction(false)
                } else {
                    cancelSubmit()
                }
            }
        }
    }, [responseStatusProduct])

    const additionalFormikUpdate = (data) => {
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const validationArray = Yup.object({
        asin: Yup.string().required('Required!'),
    })

    const validationHomeArray = Yup.object({
        home_depot: Yup.string().required('Required!'),
    })

    const validationXBarArray = Yup.object({
        x_barcode: Yup.string().required('Required!'),
    })

    const validationUpcArray = Yup.object({
        upc_id: Yup.number().required('Required!'),
    })

    const formikAsin = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            asin: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            retrieveProduct(values)
            formikHomeDepot.values.home_depot = ''
            formikUpc.values.upc_id = ''
        },
    })
    const formikHomeDepot = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            home_depot: '',
        },
        validateOnBlur: false,
        validationSchema: validationHomeArray,
        onSubmit: (values) => {
            retrieveHomeDepot(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikXBarCode = useFormik({
        initialValues: {
            user_id: user?.admin_id,
            x_barcode: '',
        },
        validateOnBlur: false,
        validationSchema: validationXBarArray,
        onSubmit: (values) => {
            retrieveHomeDepot(values)
            formikAsin.values.asin = ''
            formikUpc.values.upc_id = ''
        },
    })

    const formikUpc = useFormik({
        initialValues: {
            upc_id: '',
        },
        validateOnBlur: false,
        validationSchema: validationUpcArray,
        onSubmit: (values) => {
            retrieveUpcProduct(values)
            formikAsin.values.asin = ''
            formikHomeDepot.values.home_depot = ''
        },
    })

    const categoryFilter = (value, fieldname) => {
        let arrayData = [...props.fieldValue]
        console.log(arrayData, 'array')
        let filterValue = ''
        arrayData.map((data, index) => {
            if (data.type === 'select') {
                console.log(
                    typeof fieldname,
                    value,
                    alldata_all_dropdown,
                    'kkkk'
                )
                if (value !== null) {
                    if (!data.diff_value) {
                        let idValue = {}
                        idValue = alldata_all_dropdown.filter(
                            (item) =>
                                item.description === `${value}` &&
                                item.variable === `${fieldname}`
                        )
                        console.log(idValue, 'idddd')
                        if (idValue.length) {
                            let values = idValue[0]
                            filterValue = values.id
                        }
                    }
                }
            }
        })
        return filterValue
    }

    const dimensionFunction = (data) => {
        let arrayData = []
        if (data && data.length) {
            data.map((item) => {
                if (item.key === 'Dimensions') {
                    item.value.map((key) => {
                        var regExp = /\(([^)]+)\)/
                        var matches = regExp.exec(key.name)
                        if (matches.length) {
                            if (matches[1] == 'in.') {
                                arrayData.units = 'inch'
                                if (key.name === 'Product Depth (in.)') {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.height = numb.join('')
                                } else if (
                                    key.name === 'Product Height (in.)'
                                ) {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.height = numb.join('')
                                } else if (
                                    key.name === 'Product Length (in.)'
                                ) {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.length = numb.join('')
                                } else if (key.name === 'Product Width (in.)') {
                                    var txt = key.value
                                    var numb = txt.match(/\d/g)
                                    arrayData.width = numb.join('')
                                }
                            } else {
                                arrayData.units = 'centimeter'
                            }
                        }
                    })
                }
            })
        }

        console.log(arrayData, 'dimennn')
        return arrayData
    }

    useEffect(() => {
        if (upc_products && upc_products.record) {
            console.log(upc_products, 'uppp')
            if (
                upc_products?.record.asin &&
                Object.keys(upc_products.record.asin).length
            ) {
                let asinFetchValue = upc_products.record.asin
                let categoryValue = categoryFilter(
                    asinFetchValue?.category,
                    'category'
                )
                let asinTempValue = {
                    record: {
                        title: asinFetchValue?.title,
                        auction: 1,
                        shipping_enable: 1,
                        dimension_length:
                            asinFetchValue?.packageDimensions?.length,
                        dimension_width:
                            asinFetchValue?.packageDimensions?.width,
                        dimension_height:
                            asinFetchValue?.packageDimensions?.height,
                        weight_value: asinFetchValue?.packageDimensions?.weight,
                        sku: asinFetchValue?.mpn,
                        brand: asinFetchValue?.brand,
                        upc: asinFetchValue?.upc,
                        category: categoryValue,
                        uploadimages: asinFetchValue?.uploadimages,
                        auctiontype: 'live',
                    },
                }
                let mapData = []
                mapData = [...propsFieldValue]
                if (mapData.length) {
                    mapData.map((data, index) => {
                        if (data.name === 'auctionid') {
                            data.options = allautiondetails
                                ? allautiondetails
                                : []
                        }
                    })
                }
                let index = mapData.findIndex((e) => e.name === 'buynow')
                const array = {
                    type: 'misc',
                    content: [
                        <a
                            target="_blank"
                            onClick={viewTerms}
                            className="text-danger"
                        >
                            {`Check Amazon Price? - ${
                                asinFetchValue?.lowestNewPrice !== null
                                    ? asinFetchValue?.lowestNewPrice
                                    : '0'
                            }`}
                        </a>,
                    ],
                    class: 'col-12',
                    show_order: 7,
                }
                let orderedArray = addAfter(mapData, index, array)
                setFieldData(orderedArray)
                setTimeout(() => {
                    if (orderedArray.length) {
                        setAsinValue(asinTempValue)
                    }
                }, 2000)
            } else if (
                upc_products?.record.upc &&
                Object.keys(upc_products.record.upc).length
            ) {
                let upcFetchValue = upc_products?.record.upc
                let asinTempValue = {
                    record: {
                        title: upcFetchValue?.title,
                        auction: 1,
                        desc_proc: upcFetchValue?.description,
                        uploadimages: upcFetchValue?.images?.toString(),
                    },
                }
                let mapData = []
                mapData = [...propsFieldValue]
                let index = mapData.findIndex((e) => e.name === 'buynow')

                let data = upcFetchValue?.description
                const array = {
                    type: 'misc',
                    content: [
                        <a
                            target="_blank"
                            onClick={() => viewUpc(data)}
                            className="text-danger"
                        >
                            {`Check UPC Price? - ${
                                upcFetchValue?.msrp !== null
                                    ? upcFetchValue?.msrp
                                    : '0'
                            }`}
                        </a>,
                    ],
                    class: 'col-6 col-xs-12',
                    show_order: 7,
                }

                let orderedArray = addAfter(mapData, index, array)
                setFieldData(orderedArray)
                console.log(asinTempValue, 'asinnoo')
                setTimeout(() => {
                    if (orderedArray.length) {
                        setAsinValue(asinTempValue)
                    }
                }, 2000)
            }
        }
    }, [upc_products])

    useEffect(() => {
        if (homedepot_products.record) {
            // let categoryValue = categoryFilter(homedepot_products.record?.category, 'category')
            let dimensionValue = dimensionFunction(
                homedepot_products.record?.product_results?.specifications
            )

            let asinTempValue = {
                record: {
                    title: homedepot_products.record?.product_results?.title,
                    desc_proc:
                        homedepot_products.record?.product_results?.description,
                    auction: 1,
                    brand: homedepot_products.record?.product_results?.brand
                        ?.name,
                    upc: homedepot_products.record?.product_results?.upc,
                    uploadimages:
                        homedepot_products.record?.uploadimages?.toString(),
                    shipping_enable: 1,
                    dimension_unit: dimensionValue.units,
                    dimension_width: dimensionValue.width,
                    dimension_height: dimensionValue.height,
                    dimension_length: dimensionValue.length,
                },
            }
            // let mapData = []
            // mapData = [...propsFieldValue]
            // let index = mapData.findIndex((e) => e.name === 'buynow')

            // let data = homedepot_products.record?.product_results?.link
            // const array = {
            //     type: 'misc',
            //     content: [
            //         <a target="_blank" onClick={() => viewHomeDepot(data)} className="text-danger">
            //             {`Check HomeDepot Price? - ${
            //                 homedepot_products.record?.product_results?.price !== null
            //                     ? homedepot_products.record?.product_results?.price
            //                     : '0'
            //             }`}
            //         </a>,
            //     ],
            //     class: 'col-6 col-xs-12',
            //     show_order: 7,
            // }

            // let orderedArray = addAfter(mapData, index, array)
            // setFieldData(orderedArray)
            setTimeout(() => {
                setAsinValue(asinTempValue)
            }, 2000)
        }
    }, [homedepot_products])

    useEffect(() => {
        if (all_products.record) {
            let categoryValue = categoryFilter(
                all_products.record?.category,
                'category'
            )
            let asinTempValue = {
                record: {
                    title: all_products.record?.title,
                    auction: 1,
                    shipping_enable: 1,
                    dimension_length:
                        all_products.record?.packageDimensions?.length,
                    dimension_width:
                        all_products.record?.packageDimensions?.width,
                    dimension_height:
                        all_products.record?.packageDimensions?.height,
                    weight_value:
                        all_products.record?.packageDimensions?.weight,
                    sku: all_products.record?.mpn,
                    brand: all_products.record?.brand,
                    upc: all_products.record?.upc,
                    category: categoryValue,
                    uploadimages: all_products.record?.uploadimages,
                    auctiontype: 'live',
                },
            }
            let mapData = []
            mapData = [...propsFieldValue]
            if (mapData.length) {
                mapData.map((data, index) => {
                    if (data.name === 'auctionid') {
                        data.options = allautiondetails ? allautiondetails : []
                    }
                })
            }
            let index = mapData.findIndex((e) => e.name === 'buynow')
            const array = {
                type: 'misc',
                content: [
                    <a
                        target="_blank"
                        onClick={viewTerms}
                        className="text-danger"
                    >
                        {`Check Amazon Price? - ${
                            all_products.record?.lowestNewPrice !== null
                                ? all_products.record?.lowestNewPrice
                                : '0'
                        }`}
                    </a>,
                ],
                class: 'col-12',
                show_order: 7,
            }
            let orderedArray = addAfter(mapData, index, array)
            setFieldData(orderedArray)
            setTimeout(() => {
                if (orderedArray.length) {
                    setAsinValue(asinTempValue)
                }
            }, 2000)
        }
    }, [all_products])

    const viewHomeDepot = (data) => {
        window.open(`${data}`)
    }

    const viewUpc = (data) => {
        window.open(`${data}`)
    }

    const viewTerms = () => {
        window.open(
            `https://www.amazon.com/dp/${formikAsin.values.asin}?%2Ftag=auction0f2-20&th=1`
        )
    }
    const addAfter = (array, index, newItem) => {
        return [...array.slice(0, index), newItem, ...array.slice(index)]
    }

    useEffect(() => {
        let mapData = [...propsFieldValue]
        if (mapData.length) {
            mapData.map((data, index) => {
                if (data.name === 'auctionid') {
                    data.options = allautiondetails ? allautiondetails : []
                }
            })
            setFieldData(mapData)
            setReload(!reload)
            setIsLoading(false)
        }
    }, [propsFieldValue, props.data])

    const asinData = {
        formik: formikAsin,
        data: asinMapData,
    }

    const homeData = {
        formik: formikHomeDepot,
        data: homeMapData,
    }

    const upcData = {
        formik: formikUpc,
        data: upcMapData,
    }

    const xBarData = {
        formik: formikXBarCode,
        data: xBarMapData,
    }

    const resetFormikAsin = () => {
        formikAsin.values.asin = ''
    }

    const resetFormikHome = () => {
        formikHomeDepot.values.home_depot = ''
    }

    const resetFormikXBar = () => {
        formikXBarCode.values.x_barcode = ''
    }

    const resetFormikUpc = () => {
        formikUpc.values.upc_id = ''
    }

    const submitFunction = () => {
        setIsLoading(true)
        const value = formikValues
        /* It is for duplicate lot posting */
        if (data && data?.status === 'duplicate') {
            value.id = 0
            value.market_status = 'draft'
        }
        if (value.reverseauction) {
            value.auctiontype = 'reverse'
        }
        if (value.market_status === 'draft' && data?.status !== 'duplicate') {
            if (value.date_added) {
                value.date_added = moment(
                    value.date_added,
                    'MM-DD-YYYY h:mm a'
                ).format()
            } else if (value.date_closed) {
                value.date_closed = moment(
                    value.date_closed,
                    'MM-DD-YYYY h:mm a'
                ).format()
            }
        }
        if (props.userId) {
            if (props.userId !== null) {
                value.user_id = props.userId
            }
        }
        projectAction(value)
    }

    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        submitFunction()
    }
    console.log(data, 'ddddd')

    const cancelSubmit = () => {
        setIsLoading(false)
        toggleFullScreenPopup(false, '', 0)
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data?.status !== 'editTemplate') {
            if (data?.status === 'newTemplate') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data?.id])

    useEffect(() => {
        const buttonDataTemp = []
        if (data && data?.status === 'duplicate') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: 'Duplicate',
                additionalValue: 'open',
            })
        } else {
            if (formikValues.id) {
                if (formikValues.market_status === 'draft') {
                    buttonDataTemp.push({
                        type: props.draftValidate ? 'submit' : 'button',
                        style: 'secondary',
                        label: props.draftValidate ? 'submit' : 'Save as Draft',
                        additionalValue: 'draft',
                    })
                    if (!props.noSubmitBtn) {
                        buttonDataTemp.push({
                            type: 'submit',
                            style: 'primary',
                            label: 'Submit',
                            additionalValue: 'open',
                        })
                    }
                }
                if (formikValues.market_status === 'open') {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Update',
                        additionalValue: 'open',
                    })
                }
            } else {
                // buttonDataTemp.push({
                //     type: props.draftValidate ? 'submit' : 'button',
                //     style: 'secondary',
                //     label: 'Save as Draft',
                //     additionalValue: 'draft',
                // })
                if (!props.noSubmitBtn) {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: 'Submit',
                        additionalValue: 'open',
                    })
                }
            }
        }

        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status, data?.status])

    return props.standalone ? (
        <>
            {isLoading ? (
                <div className="fspLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    {console.log(asinMapData, 'asinn')}
                    {asinMapData?.length &&
                    props.data?.status === 'newTemplate' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <form
                                        onSubmit={formikAsin.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(asinData)}
                                        <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}
                    {homeMapData?.length &&
                    props.data?.status === 'newTemplate' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <form
                                        onSubmit={formikHomeDepot.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(homeData)}
                                        <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}

                    {xBarData?.length &&
                    props.data?.status === 'newTemplate' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <form
                                        onSubmit={formikXBarCode.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(xBarData)}
                                        <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}

                    {upcMapData?.length &&
                    props.data?.status === 'newTemplate' ? (
                        <>
                            <div className="commActBox d-flex justify-content-between align-items-center">
                                <div className="w-100">
                                    <form
                                        onSubmit={formikUpc.handleSubmit}
                                        className="row flex-wrap d-flex justify-content-start align-items-center"
                                    >
                                        {mapData(upcData)}
                                        <div className="col-auto ml-auto btnSearch">
                                            <PrimaryButton
                                                id="fetch"
                                                label="FETCH"
                                                btnSize="small"
                                                type="submit"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </>
                    ) : null}
                    <BaseActionPage
                        arrayValue={fieldData}
                        data={props.data}
                        additionalFormikUpdate={additionalFormikUpdate}
                        editFunction={getSingleProject}
                        editValue={single_project}
                        handleMapDataValue={handleMapDataValue}
                        actionFunction={formSubmit}
                        cancelFunction={cancelSubmit}
                        buttonAction={buttonData}
                        customValidation={customValidation}
                        customInitialValues={customInitialValues}
                        showasin={
                            asinMapData?.length
                                ? props.data?.status === 'newTemplate'
                                    ? true
                                    : false
                                : false
                        }
                        homeDepot={
                            homeMapData?.length
                                ? props.data?.status === 'newTemplate'
                                    ? true
                                    : false
                                : false
                        }
                        all_products={asinValue}
                    />
                </>
            )}
        </>
    ) : (
        <FullScreenPopup
            modaltitle={
                data?.status === 'newTemplate'
                    ? 'ADD NEW CATALOGUE LISTING'
                    : data?.status === 'duplicate'
                    ? 'Edit Duplicate Lot'
                    : 'EDIT CATALOGUE LISTING'
            }
            open={
                data.status === 'newTemplate' || data.status === 'editTemplate'
                    ? data.popup
                    : false
            }
            handleClose={() => {
                setIsLoading(false), toggleFullScreenPopup(false, '', 0)
            }}
        >
            <div className="addUserModal">
                <div className="fspBody">
                    {isLoading ? (
                        <div className="fspLoader">
                            <Loaders isLoading={isLoading} />
                        </div>
                    ) : (
                        <>
                            {asinMapData?.length &&
                            props.data?.status === 'newTemplate' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <form
                                                onSubmit={
                                                    formikAsin.handleSubmit
                                                }
                                                className="row flex-wrap d-flex justify-content-start align-items-center"
                                            >
                                                {mapData(asinData)}
                                                <div className="col-auto ml-auto btnSearch">
                                                    <PrimaryButton
                                                        id="fetch"
                                                        label="FETCH"
                                                        btnSize="small"
                                                        type="submit"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            {homeMapData?.length &&
                            props.data?.status === 'newTemplate' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <form
                                                onSubmit={
                                                    formikHomeDepot.handleSubmit
                                                }
                                                className="row flex-wrap d-flex justify-content-start align-items-center"
                                            >
                                                {mapData(homeData)}
                                                <div className="col-auto ml-auto btnSearch">
                                                    <PrimaryButton
                                                        id="fetch"
                                                        label="FETCH"
                                                        btnSize="small"
                                                        type="submit"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            {upcMapData?.length &&
                            props.data?.status === 'newTemplate' ? (
                                <>
                                    <div className="commActBox d-flex justify-content-between align-items-center">
                                        <div className="w-100">
                                            <form
                                                onSubmit={
                                                    formikUpc.handleSubmit
                                                }
                                                className="row flex-wrap d-flex justify-content-start align-items-center"
                                            >
                                                {mapData(upcData)}
                                                <div className="col-auto ml-auto btnSearch">
                                                    <PrimaryButton
                                                        id="fetch"
                                                        label="FETCH"
                                                        btnSize="small"
                                                        type="submit"
                                                    />
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            <BaseActionPage
                                arrayValue={fieldData}
                                data={props.data}
                                additionalFormikUpdate={additionalFormikUpdate}
                                editFunction={getSingleProject}
                                editValue={single_project}
                                handleMapDataValue={handleMapDataValue}
                                actionFunction={formSubmit}
                                cancelFunction={cancelSubmit}
                                buttonAction={buttonData}
                                customValidation={customValidation}
                                customInitialValues={customInitialValues}
                                showasin={
                                    asinMapData?.length
                                        ? props.data?.status === 'newTemplate'
                                            ? true
                                            : false
                                        : false
                                }
                                homeDepot={
                                    homeMapData?.length
                                        ? props.data?.status === 'newTemplate'
                                            ? true
                                            : false
                                        : false
                                }
                                all_products={asinValue}
                                // mapDataValue={mapDataValue}
                                // resetMapData={resetMapData}
                                // setResetMapData={setResetMapData}
                            />

                            {/* </form> */}
                        </>
                    )}
                </div>
            </div>
        </FullScreenPopup>
    )
}

export default ProductFieldsView
